<!--
 * @Author: Tahiti
 * @Date: 2025-06-26 17:19:13
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-02 16:26:47
 * @Description: 
 * @FilePath: /weryai-web/components/VideoPreview.vue
-->
<template>
    <transition name="fade">
        <div v-if="visible" class="preview-mask" @click.self="close">
            <video
                :src="url"
                class="preview-video"
                crossorigin="anonymous"
                controls
                autoplay
                playsinline
                webkit-playsinline
            />
            <span class="close-btn" @click="close"> × </span>
        </div>
    </transition>
</template>

<script setup>
import { onMounted, onBeforeUnmount } from 'vue'
import { emitter } from '~/utils/emitter'

const visible = ref(false)

const url = ref('')

function close() {
    visible.value = false
}

function handleKeydown(e) {
    if (e.key === 'Escape' && visible.value) {
        close()
    }
}

const openVideoPreview = videoUrl => {
    visible.value = true
    url.value = videoUrl
}

onMounted(() => {
    emitter.on('open-video-preview', videoUrl => {
        console.log(videoUrl)

        openVideoPreview(videoUrl)
    })
    emitter.on('close-video-preview', () => {
        close()
    })
    window.addEventListener('keydown', handleKeydown)
})
onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleKeydown)
    emitter.off('open-video-preview', videoUrl => {
        openVideoPreview(videoUrl)
    })
    emitter.off('close-video-preview', () => {
        close()
    })
})
</script>

<style scoped lang="less">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
.preview-mask {
    position: fixed;
    z-index: 9999;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgb(0 0 0 / 40%);
    backdrop-filter: blur(5px);
    display: flex;
    align-items: center;
    justify-content: center;
}
.preview-img {
    max-width: 90vw;
    max-height: 90vh;
    border-radius: 8px;
    box-shadow: 0 4px 32px rgba(0, 0, 0, 0.25);
    background: #fff;
    object-fit: contain;
}
.preview-video {
    max-width: 90vw;
    max-height: 90vh;
    border-radius: 8px;
    box-shadow: 0 4px 32px rgba(0, 0, 0, 0.25);
    object-fit: contain;
}
.close-btn {
    position: fixed;
    top: 32px;
    right: 48px;
    font-size: 40px;
    color: #fff;
    cursor: pointer;
    z-index: 10000;
    user-select: none;
    font-weight: bold;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 5px;
}
.close-btn:hover {
    color: var(--weryai-text-active);
}
</style>
